<fui-modal [state]="state" [maxWidth]="'700px'" [maxHeight]="'600px'">
    <fui-modal-window>
        <fui-modal-window-toolbar (closed)="cancel()" [title]="'Customer Sign Up'">
        </fui-modal-window-toolbar>
        <fui-modal-window-main>
            <div class="content">
                <div class="content-message">
                    <p>Please check all information before submitting to the customer as this information is used to generate the Customer Agreement.</p>
                </div>

                <div class="content-actions">
                    <fui-action-button [title]="'Sign in person now'" (click)="signUpInPerson()">
                    </fui-action-button>
                    <div class="content-spacer">or</div>
                    <fui-action-button [title]="'Email sign up link'" (click)="sendSignUpUrl()">
                    </fui-action-button>
                </div>

                <div class="content-footer">
                    <p>If a contract needs to be manually uploaded or if the customer is not ready to sign yet, then <a class="action-link" (click)="signUpLater()">sign up later</a>.</p>
                </div>
            </div>
        </fui-modal-window-main>
        <fui-modal-window-footer>
            <fui-buttons>
                <fui-action-button class="content-cancel-button"
                                   [title]="'fhm.common.button.cancel'"
                                   (click)="cancel()">
                    <fui-icon [height]="12" [icon]="'close'" [width]="12"></fui-icon>
                </fui-action-button>
            </fui-buttons>
        </fui-modal-window-footer>
    </fui-modal-window>
</fui-modal>
